export const environment = {
  feUrl: 'https://portaletest.apss.tn.it/authenticator/',
  beUrl: 'https://portaletest.apss.tn.it/api/',
  baseUrl: 'https://portaletest.apss.tn.it/',
  administrationUrl: 'https://portaletest.apss.tn.it/api/administration/',
  isLocal: false,
  production: false,
  publicKey:
    '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCpM7QCHFFrvBGDAjrqdeDfRX3HrvecNTc3/KQ7Ws7W66eM28j9DOYuXnWXQtKOB9V0481NsZHJaCIQEj3IvTfeamO8bPFNo5dRt7oAXMOXkK+uWXZvKV/ZjsqLBbaOkgy3G9P8DqyiStJ2yn6wwNwIFBLla5S8oHWLai9YhR/VcQIDAQAB-----END PUBLIC KEY-----',
};
